



import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock, faCreditCard, faShieldHalved } from '@fortawesome/free-solid-svg-icons';
import API from '../api'; // Assuming this exists as per your previous files
import Header from '../headerFooter/header';
import HomeFooter from '../homepage/homefooter';
import styles from './PaymentPage.module.css';

const PaymentPage = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  
  const { formData, yogaRegistrationData, FemaleWellnessData, productName, amount } = state || {};
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  // Construct user details wrapper to avoid prop drilling logic in JSX
  const userDetails = formData || yogaRegistrationData || FemaleWellnessData || {};
  const contactEmail = userDetails.email || 'guest@example.com';
  const contactPhone = userDetails.phone || userDetails.mobileNumber || '0000000000';
  const contactName = userDetails.name || userDetails.fullName || 'Guest';

  const handlePayment = async () => {
    setLoading(true);
    setError(null);

    try {
      const { data } = await API.post(
        '/payment',
        { amount, currency: 'INR' },
        { headers: { 'Content-Type': 'application/json' }, withCredentials: true }
      );

      const options = {
        // key: 'rzp_live_RtrNxMD7wiRp1V', 
        key: process.env.REACT_APP_RAZORPAY_KEY_ID,
        amount: data.amount,
        currency: data.currency,
        name: 'Satvic Path',
        description: `Order: ${productName}`,
        order_id: data.id,
        handler: function (response) {
          navigate('/confirmation', {
            state: { ...state, paymentId: response.razorpay_payment_id },
          });
        },
        prefill: { name: contactName, email: contactEmail, contact: contactPhone },
        theme: { color: '#2F855A' }, // Matched with primary color
      };

      const razorpay = new window.Razorpay(options);
      razorpay.on('payment.failed', (res) => setError(`Payment Failed: ${res.error.description}`));
      razorpay.open();
    } catch (err) {
      console.error(err);
      setError('Unable to initiate payment. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  // Helper to render specific details based on what data is available
  const renderDetails = () => {
    if (formData) {
      return (
        <>
          <p>{formData.name}</p>
          <p>{formData.houseNo}, {formData.street}</p>
          <p>{formData.city}, {formData.state} - {formData.pincode}</p>
          <p>{formData.country}</p>
        </>
      );
    }
    // Fallback for other forms
    return (
      <>
        <p>{contactName}</p>
        <p>{contactEmail}</p>
        <p>+91 {contactPhone}</p>
      </>
    );
  };

  return (
    <div className={styles.container}>
      <Header />
      
      <div className={styles.contentWrapper}>
        <div className={styles.card}>
          <div className={styles.cardHeader}>
            <h2>Total Payable</h2>
            <div className={styles.amount}>₹{amount}</div>
          </div>

          <div className={styles.cardBody}>
            
            <div className={styles.summarySection}>
                <div className={styles.summaryRow}>
                    <span>Product</span>
                    <span>{productName}</span>
                </div>
                <div className={styles.summaryRow}>
                    <span>Subtotal</span>
                    <span>₹{amount}</span>
                </div>
                <div className={styles.summaryRow}>
                    <span>Total</span>
                    <span>₹{amount}</span>
                </div>
            </div>

            <div className={styles.detailBlock}>
                <h4>{formData ? "Shipping To" : "Subscriber Details"}</h4>
                {renderDetails()}
            </div>

            {error && <div className={styles.error}>{error}</div>}

            <button 
                className={styles.payButton} 
                onClick={handlePayment} 
                disabled={loading || !amount}
            >
                {loading ? 'Processing...' : <><FontAwesomeIcon icon={faCreditCard} /> Pay Securely</>}
            </button>

            <div className={styles.secureBadge}>
                <FontAwesomeIcon icon={faShieldHalved} />
                <span>256-bit SSL Secured Payment by Razorpay</span>
            </div>

          </div>
        </div>
      </div>

      <HomeFooter />
    </div>
  );
};

export default PaymentPage;